import { ConfirmModalOptions } from 'redux/mode/reducers';
import Modal from '..';
import { showConfirmModal } from 'redux/mode/actions';
import { useDispatch } from 'react-redux';
import { useState } from 'react';

interface ConfirmModalProps {
	options: ConfirmModalOptions;
}

const ConfirmModal = ({ options }: ConfirmModalProps) => {
	const {
		title,
		cancelLabel,
		submitLabel,
		altActionLabel,
		description,
		onCancel,
		onSubmit,
		onAltAction,
	} = options;
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);

	const onKeyPress = (e: React.KeyboardEvent<HTMLElement>) => {
		if (e.key === 'Enter' && !e.shiftKey && !loading) {
			e.preventDefault();
			submit();
		}
	};

	const closeModal = () => {
		dispatch(showConfirmModal(null));
	};

	const cancel = onCancel
		? () => {
				if (loading) return;
				closeModal();
				onCancel();
		  }
		: () => {
				if (loading) return;
				closeModal();
		  };

	const submit = async () => {
		const result = onSubmit();
		if (result instanceof Promise) {
			setLoading(true);
			try {
				await result;
				closeModal();
			} catch (error) {
				// Error handling is done by the onSubmit function
				// Keep modal open so user can see error or retry
				setLoading(false);
			}
		} else {
			closeModal();
		}
	};

	const altAction =
		onAltAction &&
		(() => {
			if (loading) return;
			closeModal();
			onAltAction();
		});

	const onClickOutside = (e: { preventDefault: () => void }) => {
		if (loading) {
			e.preventDefault();
			return;
		}
		e.preventDefault();
		closeModal();
	};

	return (
		<div onKeyDownCapture={onKeyPress}>
			<Modal
				disabled={false}
				loading={loading}
				cancelLabel={cancelLabel ?? null}
				submitLabel={submitLabel}
				altActionLabel={altActionLabel}
				title={title}
				description={description}
				onCancel={cancel}
				onSubmit={submit}
				onAltAction={altAction}
				onClickOutside={onClickOutside}
				cancelDisabled={loading}
			/>
		</div>
	);
};

export default ConfirmModal;
